import { CustomFieldType, ExpenseReportQuery } from "@common/utils/graphql";
import { ExtractTypename } from "@common/utils/graphql/utils";
import { Body } from "@hypercard/web-components";

export type CustomFieldValues = ExtractTypename<
  ExpenseReportQuery["expenseReport"],
  "QueryExpenseReportSuccess"
>["data"]["expenses"][number]["customFieldEntries"];

type Props = {
  customFieldEntries: CustomFieldValues;
};
export const ExpenseCustomFieldValues = ({ customFieldEntries }: Props) => {
  return (
    <>
      {customFieldEntries
        .filter(
          (entry) =>
            !!entry.customFieldListOptionId ||
            !!entry.rawValue ||
            typeof entry.booleanValue === "boolean",
        )
        .map((entry) => {
          if (entry.type === CustomFieldType.ShortText) {
            return (
              <div key={`custom-field-values--${entry.customFieldEntityId}`}>
                <Body size="sm" weight="regular" className="text-white/70">
                  {entry.customFieldEntity.name}
                </Body>
                <Body size="md" weight="regular">
                  {entry.rawValue}
                </Body>
              </div>
            );
          } else if (entry.type === CustomFieldType.Checkbox) {
            return (
              <div key={`custom-field-values--${entry.customFieldEntityId}`}>
                <Body size="sm" weight="regular" className="text-white/70">
                  {entry.customFieldEntity.name}
                </Body>
                <Body size="md" weight="regular">
                  {entry.booleanValue ? "Yes" : "No"}
                </Body>
              </div>
            );
          } else {
            const { name, value } =
              entry.customFieldEntity.listOptions?.find(
                (listOption) => listOption.id === entry.customFieldListOptionId,
              ) ?? {};
            return (
              <div key={`custom-field-values--${entry.customFieldEntityId}`}>
                <Body size="sm" weight="regular" className="text-white/70">
                  {entry.customFieldEntity.name}
                </Body>
                <Body size="md" weight="regular">
                  {name}
                  <span className="text-body-sm text-white/70">{` - ${value}`}</span>
                </Body>
              </div>
            );
          }
        })}
    </>
  );
};
